import { PageHeader } from "@/components/rp";
import { SopralluoghiPanel } from "@/components/admin/sopralluoghi";

export default function AdminSopralluoghi() {
  return (
    <div className="space-y-6" data-testid="admin-sopralluoghi-page">
      <PageHeader label="Sopralluoghi" title="Dal cantiere al preventivo" />
      <SopralluoghiPanel />
    </div>
  );
}
